import React from 'react';
import PropTypes from 'prop-types';

import GenericPageShared from '@landing_academy/shared/components-mantine/GenericPage';

import { useLandingData } from '../../hooks/homePage';
import { AppContext } from '../provider';


function GenericPage({ pageContext }) {
  const landingData = useLandingData();

  return (
    <AppContext.Consumer>
      {({ setter }) => (
        <GenericPageShared
          pageContext={pageContext}
          landingData={landingData}
          apriFormContattoFunction={() => setter({ formContattoOpened: true })}
        />
      )}
    </AppContext.Consumer>
  );
}

GenericPage.propTypes = {
  pageContext: PropTypes.shape({
    heroAbilita: PropTypes.bool,
    heroSottotitolo: PropTypes.string,
    heroFeatures: PropTypes.array,
    heroButtons: PropTypes.array,
    heroTitolo: PropTypes.string,
    heroImage: PropTypes.object,
    featuresAbilita: PropTypes.bool,
    featuresSottotitolo: PropTypes.string,
    featuresTitolo: PropTypes.string,
    featuresList: PropTypes.array,
    featuresButtons: PropTypes.array,
    formContattiAbilita: PropTypes.bool,
    tabelleAbilita: PropTypes.bool,
    licenzeList: PropTypes.array,
    tabelleTitolo: PropTypes.string,
    licenzeButtons: PropTypes.array,
    faqAbilita: PropTypes.bool,
    faqTitolo: PropTypes.string,
    faqList: PropTypes.array,
    titoloPagina: PropTypes.string,
    contenutoTestuale: PropTypes.string,
    mostraButtonFormContatto: PropTypes.bool,
  }),
};

export default GenericPage;
